<!--
 * @Author: hfxie
 * @Date: 2022-08-30 16:30:40
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-11-28 10:44:01
 * @Description: 单个分类区块·右侧·行
-->
<template>
  <div class="zone-row-right">

    <div
      class="zone-row"
      :style="{
        'color': (row.color || '')
      }"
      @contextmenu.prevent.stop
    >
      <template v-if="header[block.cellKey] instanceof Array">
        <template v-for="(rowCell, rowCellIndex) in row.cellList">
          <template v-if="header[block.cellKey][rowCellIndex]">
            <el-tooltip
              v-if="rowCell.tips"
              :key="rowCellIndex + rowCell.val + '_1'"
              class="zone-header-col item"
              :content="rowCell.tips"
              placement="top"
              >
              <span
                class=""
                :style="{
                  'width': header[block.cellKey][rowCellIndex].colWidth + 'px',
                  'font-size': header[block.cellKey][rowCellIndex].fontSize + 'px',
                  'text-align': header[block.cellKey][rowCellIndex].colAlign,
                  'color': rowCell.color? rowCell.color: '',
                }"
              >
                {{rowCell.val? rowCell.val: "/"}}
              </span>
            </el-tooltip>
            <span
              v-else
              class="zone-header-col"
              :key="rowCellIndex + rowCell.val + '_2'"
              :style="{
                'width': header[block.cellKey][rowCellIndex].colWidth + 'px',
                'font-size': header[block.cellKey][rowCellIndex].fontSize + 'px',
                'text-align': header[block.cellKey][rowCellIndex].colAlign,
                'color': rowCell.color? rowCell.color: '',
              }"
            >
              {{rowCell.val? rowCell.val: "/"}}
            </span>
          </template>

        </template>
        <!-- <span
          class="zone-header-col"
          v-for="(rowCell, rowCellIndex) in row.cellList"
          v-if="header[block.cellKey][rowCellIndex]"
          :key="rowCellIndex + rowCell.val"
          :style="{
            'width': header[block.cellKey][rowCellIndex].colWidth + 'px',
            'font-size': header[block.cellKey][rowCellIndex].fontSize + 'px',
            'text-align': header[block.cellKey][rowCellIndex].colAlign,
          }"
        >
          {{rowCell.val? rowCell.val: "/"}}
        </span> -->
      </template>

    </div>
    <!-- <span>{{row.name}}</span> -->

    <!-- 详情 -->
    <div
      class="zone-detail"
      v-if="row.isExpand && detailsMap && detailsMap[row.detailId] && detailsMap[row.detailId].length > 0"
    >
      <!-- <div
        class="zone-detail-box"
        :style="{
          'height': detailsMap[row.detailId].length * 24 + 8 + 'px',
        }"
      ></div> -->

      <!-- 详情内容 -->
      <div
        class="zone-detail-box"
        :style="{
          'width': $store.state.local.totalWidth - 10 + 'px',
          'padding-left': row.level * 8 + 32 + 'px',
        }"
      >
        <div class="zone-detail-box-bg"></div>
        <template v-for="detailRow in detailsMap[row.detailId]">
          <div
            class="zone-detail-item"
            :key="'detail-' + detailRow.id"
          >
            {{detailRow.value + "  " + detailRow.label}}
          </div>
        </template>
      </div>

    </div>

    <!-- 子集 -->
    <template v-if="row.isExpand && row.child && row.child.length > 0">
      <template v-for="child in row.child">
        <ZoneRowRight :key="'row-' + child.id" :header="header" :block="block" :row="child" />
      </template>
    </template>

  </div>
</template>

<script>

import ZoneRowRight from "@/components/List/Zone/Right/ZoneRowRight";
export default {
  name: "ZoneRowRight",
  data() {
    return {

    };
  },
  props: {
    header: {
      type: Object,
      default: () => {
        return {};
      },
    },
    block: {
      type: Object,
      default: () => {
        return {};
      },
    },
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },

  },
  components: {
    ZoneRowRight,
  },
  computed: {
    detailsMap() {
      return this.$store.state.data.detailsMap || {};
    },

  },
  methods: {

  },
};
</script>
<style scoped lang='less'>
  .zone-row-right{
    /* 自身 */
      .zone-row{
        .text-oneline;
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        padding-left: 12px;
        color: #212121;
        font-weight: 400;
      }
      .zone-detail{
        width: 100%;
        position: relative;
        background-color: @cDetail;
        font-weight: 400;
        .zone-detail-box{
          min-width: @minContentWidth; // 310px;
          height: auto;
          color: #666666;
          box-sizing: border-box;
          padding: 4px 32px;
          /* 详情 */
          .zone-detail-item{
            .text-oneline;
            height: 24px;
            line-height: 24px;
          }

        }

      }

      .zone-row{
        padding-left: 0;
      }
      // 占位
      .zone-detail-wrap{
        position: relative;
        width: 148px;
        height: 100%;
      }
      .zone-detail{
        width: calc(100% + 148px);
        left: -148px;
        .zone-detail-box{
          min-width: auto;
          z-index: 2;
          position: sticky;
          // position: relative;
          // left: -148px;
          left: 0;
          // 背景色
          .zone-detail-box-bg{
            position: absolute;
            bottom: 0;
            left: -148px;
            z-index: -1;
            background: #FAFAFA;
            width: 148px;
            height: 100%;
          }
        }
      }

    .zone-header-col{
      .text-oneline;
      display: inline-block;
      height: 100%;
      // border-right: 1px solid red;
      padding: 0 6px;
      box-sizing: border-box;
    }

  }
</style>
